if (!customElements.get('predictive-search')) {
  class PredictiveSearch extends HTMLElement {
    constructor() {
      super();

      this.input = this.querySelector('input[type="search"]');
      this.form = this.querySelector('form');
      this.resultsContainer = this.querySelector(
        '.js-results-container'
      );
      this.btnSubmit = this.querySelector('.js-btn-submit');
      this.btnClearText = this.querySelector('.js-btn-clear-text');
      this.errorMessageContainer = this.querySelector(
        '.js-message-error'
      );
      this.errorMessageText =
        this.errorMessageContainer.querySelector('[data-text]');
      this.timeout = null;
      this.isOpen = false;
      this.drawer = this.closest('.js-drawer');

      var searchDrawerContent = document.querySelector('.drawer__content--search');
      var searchSuggestions = document.querySelector('.search-overlay__suggestions');

      this.input.addEventListener('input', e => {
        clearTimeout(this.timeout);

        this.timeout = setTimeout(() => {
          const searchTerm = this.input.value.trim();

          if (searchTerm.length <= 0) {
            this.close();
            if(DeviceDetector.isMobile() || DeviceDetector.isTablet()) {
              searchDrawerContent.style.height = 'auto';
            }
            if(searchSuggestions) {
              searchSuggestions.style.display = 'block';
            }
            return;
          }

          this.isOpen = true;
          this.getSearchResults(searchTerm);
          if(DeviceDetector.isMobile() || DeviceDetector.isTablet()) {
            searchDrawerContent.style.height = '100%';
          }
          if(searchSuggestions) {
            searchSuggestions.style.display = 'none';
          }
        }, 300);
      });

      this.input.addEventListener('keydown', e => {
        const isEscape = e.key === 'Escape';

        if (!isEscape) {
          return;
        }

        if (!this.input.value) {
          if (this.drawer) {
            this.drawer.parentElement.parentElement.toggleDrawer();
          }

          return;
        }

        this.close();
      });

      this.btnClearText.addEventListener('click', e => {
        this.close();
        searchDrawerContent.style.height = 'auto';
        if(searchSuggestions) {
          searchSuggestions.style.display = 'block';
        }
      });

      if (this.form) {
        this.form.addEventListener('submit', () => {
          const term = this.input.value.trim();
          if (term) window.RecentSearches.add(term);
        });
      }
    }

    async getSearchResults(searchTerm) {
      try {
        /* sections/predictive-search.liquid gates its results through
           mode-gate, so this response is mode-specific. Name the mode in the
           URL so it can never be served back for the other one. */
        const mode = document.body.dataset.shoppingMode || 'unset';
        const response = await fetch(
          `${Shopify.routes.root}search/suggest?q=${searchTerm}&resources[type]=product,page,article,collection,query&resources[limit]=8&section_id=predictive-search&_krudo_mode=${mode}`
        );

        if (!this.isOpen) {
          return;
        }

        if (!response.ok) {
          const error = new Error(response.status);

          throw error;
        }

        const text = await response.text();
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector(
            '#shopify-section-predictive-search'
          ).innerHTML;

        this.resultsContainer.innerHTML = resultsMarkup;
        this.open();

        // new added product cards - quick cart triggers - set event listeners
        document.querySelector('quick-cart-drawer')?.initTriggers();

      } catch (error) {
        this.errorMessageText.textContent = error.message;
        this.errorMessageContainer.classList.remove('hidden');
      }
    }

    open() {
      this.classList.add('is-open');
      this.resultsContainer.classList.remove('hidden');
      this.errorMessageContainer.classList.add('hidden');
      this.btnSubmit.setAttribute('tabindex', '-1');
      this.btnClearText.removeAttribute('disabled');
    }

    close() {
      this.isOpen = false;
      this.classList.remove('is-open');
      this.resultsContainer.classList.add('hidden');
      this.errorMessageContainer.classList.add('hidden');
      this.input.value = '';
      this.input.focus();
      this.btnSubmit.removeAttribute('tabindex');
      this.btnClearText.setAttribute('disabled', true);
    }
  }

  customElements.define('predictive-search', PredictiveSearch);
}

window.RecentSearches = window.RecentSearches || {
  STORAGE_KEY: 'krudo:recent-searches',
  MAX: 5,

  read() {
    try {
      const raw = localStorage.getItem(this.STORAGE_KEY);
      const list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list.filter(t => typeof t === 'string' && t.trim()) : [];
    } catch (e) {
      return [];
    }
  },

  write(list) {
    try {
      localStorage.setItem(this.STORAGE_KEY, JSON.stringify(list.slice(0, this.MAX)));
    } catch (e) {}
    document.dispatchEvent(new CustomEvent('recent-searches:change'));
  },

  add(term) {
    const trimmed = term.trim();
    if (!trimmed) return;
    const list = this.read().filter(t => t.toLowerCase() !== trimmed.toLowerCase());
    list.unshift(trimmed);
    this.write(list);
  },

  remove(term) {
    this.write(this.read().filter(t => t !== term));
  },

  clear() {
    this.write([]);
  }
};

if (!customElements.get('recent-searches')) {
  class RecentSearchesElement extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('[data-recent-list]');
      this.template = this.querySelector('[data-recent-template]');
      this.clearBtn = this.querySelector('[data-recent-clear]');
      this.searchAction = this.dataset.searchAction || '/search';

      if (this.clearBtn) {
        this.clearBtn.addEventListener('click', () => window.RecentSearches.clear());
      }

      this._onChange = () => this.render();
      document.addEventListener('recent-searches:change', this._onChange);

      this.render();
    }

    disconnectedCallback() {
      document.removeEventListener('recent-searches:change', this._onChange);
    }

    render() {
      if (!this.list || !this.template) return;
      const items = window.RecentSearches.read();
      this.list.innerHTML = '';
      this.classList.toggle('is-empty', items.length === 0);

      items.forEach(term => {
        const node = this.template.content.firstElementChild.cloneNode(true);
        const link = node.querySelector('[data-recent-link]');
        const removeBtn = node.querySelector('[data-recent-remove]');

        if (link) {
          link.textContent = term;
          link.href = `${this.searchAction}?q=${encodeURIComponent(term)}`;
        }
        if (removeBtn) {
          removeBtn.addEventListener('click', e => {
            e.preventDefault();
            e.stopPropagation();
            window.RecentSearches.remove(term);
          });
        }
        this.list.appendChild(node);
      });
    }
  }

  customElements.define('recent-searches', RecentSearchesElement);
}
